import './user.scss'
import '../../home/home.scss'
import { Box, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { TabPanel } from '@mui/lab'
import DatatableKytUsersConsumer from '../../../components/common/datatable/DatatableKytUsersConsumer'
import DatatableKytUsersBusiness from '../../../components/common/datatable/DatatableKytUsersBusiness'
import { TabContextByParam, useGetRouterParam } from '../../../components/common/TabsByParam'

const User = () => {
  const { t } = useTranslation(['common'])

  const paramType = useGetRouterParam('type', ['consumerUsers', 'businessUsers'], 'consumerUsers')

  return (
    <Box className="filter">
      <TabContextByParam
        param="type"
        currentValue={paramType}
        items={[
          { value: 'consumerUsers', label: t('common:consumer') },
          { value: 'businessUsers', label: t('common:business') },
        ]}
      >
        <Paper elevation={0}>
          <TabPanel value="consumerUsers">
            <DatatableKytUsersConsumer />
          </TabPanel>

          <TabPanel value="businessUsers">
            <DatatableKytUsersBusiness />
          </TabPanel>
        </Paper>
      </TabContextByParam>
    </Box>
  )
}

export default User
